import { useEffect, useState } from "react";
import Bubble from "./Bubble";
import CustomImage from "components/common/CustomImage";

export default function FunctionButton(props : {
        isActive ?: boolean, isLoading ?: boolean, isDisabled ?: boolean, lightShow ?: number,
        iconPath : string, title?: string, id?: string, className?: string,
        onClick : Function,
        children ?: any, 
        bubble ?: {
            title: string, desc?: string, videoId ?: string
        }}){
    const { children, onClick, iconPath, title, isActive = false, lightShow = 0, isLoading = false, isDisabled = false, id = '', className= '', bubble} = props ;

    const [ isShowBubble, setIsShowBubble] = useState<boolean>(false);

    const [ isLightShow, setIsLightShow ]= useState<boolean>(false)

    const clickHandler = () => {
        setIsShowBubble(false)
        !isDisabled && !isLoading && onClick()
    }

    const showBubble = () => {
        !isDisabled && !isLoading && !isActive && setIsShowBubble(true)
    }

    useEffect(() => {
        setIsLightShow(false);
    },[isActive, isLoading, isDisabled])

    return (
        <div className={`relative p-[5px] rounded-[3px] cursor-pointer ${className}  ${isLightShow ? 'light-show' : ''} ${isActive || isShowBubble && !isDisabled ? 'bg-[#D9F2FF]' : ''}`} id={id}
            onClick={clickHandler}>
            <div className={`relative group`}
                onMouseOver={showBubble}
                onMouseOut={() => setIsShowBubble(false)}>
                <div className=" flex flex-col items-center justify-center min-w-[50px]">
                {
                    isLoading ?
                    <p className="animate-spin">
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4287" className="editor-function-btn"><path d="M96 512c0-19.33 15.67-35 35-35s35 15.67 35 35c0 191.09 154.91 346 346 346s346-154.91 346-346-154.91-346-346-346c-19.33 0-35-15.67-35-35s15.67-35 35-35c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512z" fill="#10F28D" p-id="4288"></path></svg>
                    </p>
                    :
                    <CustomImage src={!isDisabled ? iconPath : iconPath.replace('.','-disabled.')} className="editor-function-btn" />
                }
                {
                    title && <span className={`${ isDisabled ? 'text-[#dbdbdb]' : 'text-[#9C9C9C]'}  text-[10px]`}>{title}</span>
                }
                </div>
                
                {                
                    isShowBubble && bubble && <Bubble {...bubble}/>
                }
            </div>
            {children}
        </div>
    )
}